import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const LegalLayout = ({ title, subtitle, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
  }, []);

  return (
    <div className="grain relative min-h-screen bg-brand-bg font-body text-white">
      <header className="border-b border-white/10">
        <div className="mx-auto flex h-[68px] max-w-4xl items-center justify-between px-5 lg:px-8">
          <Link to="/" data-testid="legal-logo" className="flex items-center gap-2">
            <img src="/brand/logo.png" alt="Kurier Connect" className="h-9 w-9 rounded-md object-contain" />
            <span className="font-heading text-sm font-extrabold uppercase tracking-[0.14em] text-white">
              Kurier<span className="text-brand-green">Connect</span>
            </span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back"
            className="inline-flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 font-body text-sm text-white/70 transition-colors hover:text-white"
          >
            <ArrowLeft className="h-4 w-4" />
            Zur Startseite
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 py-16 lg:px-8 lg:py-24">
        <h1 className="font-heading text-4xl font-extrabold tracking-tight sm:text-5xl">{title}</h1>
        {subtitle && <p className="mt-4 font-body text-base text-white/55">{subtitle}</p>}
        <div className="legal-content mt-10 space-y-8">{children}</div>
        <p className="mt-16 rounded-xl border border-brand-green/25 bg-brand-green/[0.06] px-5 py-4 font-body text-xs leading-relaxed text-brand-green/90">
          Hinweis: Dies ist eine Vorlage. Bitte ersetze alle mit [eckigen Klammern] markierten
          Platzhalter durch deine echten Angaben und lass die Texte vor Veröffentlichung von einer
          fachkundigen Stelle (z.&nbsp;B. Anwalt) prüfen.
        </p>
      </main>
    </div>
  );
};

export const LegalSection = ({ heading, children }) => (
  <section>
    {heading && <h2 className="font-heading text-xl font-bold text-white sm:text-2xl">{heading}</h2>}
    <div className="mt-3 space-y-3 font-body text-sm leading-relaxed text-white/70 sm:text-base">
      {children}
    </div>
  </section>
);
